import { render, staticRenderFns } from "./MenuDashBoardCliente.vue?vue&type=template&id=3bc9ecfb&scoped=true"
import script from "./MenuDashBoardCliente.vue?vue&type=script&lang=js"
export * from "./MenuDashBoardCliente.vue?vue&type=script&lang=js"
import style0 from "./MenuDashBoardCliente.vue?vue&type=style&index=0&id=3bc9ecfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc9ecfb",
  null
  
)

export default component.exports